import React from 'react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchOverviewDetails,
  fleetOverviewSelector,
  setOverviewDetails,
  setParameters,
  filterCountSelector,
  setCount,
} from 'redux/fleets/ducks';
import { NAComponent } from 'pages/TireInventory/TireInventoryItems/FleetTireInventory';
import i18next from 'i18next';
import { useMemo } from 'react';
import CustomTable from 'components/custom/CustomTableTemp';
import { Link } from 'react-router-dom';
import { Button, useTheme } from '@mui/material';
import {
  formatDate,
  getRemainingMonths,
} from 'pages/TireInventory/TireInventory';
import CommonGridItem from '../CommonGridItem';
import Loading from 'components/Loading';
import { fetchAllResources } from '../VehicleOverviewPage/VehicleOverviewPage';
import LoadAnimation from 'components/LoadAnimation';
import { debounce } from 'lodash';
import { LocaleNumberFormat, renderStatus } from 'utils/helper';
import {
  fetchTireOverviewColumnDisplay,
  setAccessTokenSelector,
} from 'redux/users/ducks';
import ColumnsEditDrawer from 'components/ColumnsEditDrawer';
import {
  getVehicleOverviewDetails,
  getFilteredTireOverview,
} from 'services/fleet_service';
import { TireOverviewFIlterDrawer } from 'components/FIlterDrawer/TireOverViewFilterDrawer';

const TireOverview = () => {
  const { t } = useTranslation();
  const parameters = useSelector(state => state.fleet.parameters);
  const dispatch = useDispatch();
  const currentLanguage = i18next.language;
  const tires = useSelector(state => state.fleet.tires);
  const count = useSelector(filterCountSelector);
  const isLoading = useSelector(state => state.fleet.isLoadingOverviewData);
  const tireOverview = useSelector(state => state.fleet.tireOverview);
  const theme = useTheme();
  const fleets = useSelector(fleetOverviewSelector)?.fleets;
  const results = useSelector(state => state.fleet.searchResults);
  const [params_, setParams_] = useState({
    accessing: 'ONLY_TIRE',
    tire_location: parameters?.tireLocation || 'IN_USE',
    page_no: 0,
  });
  const [searchQuery, setSearchQuery] = useState(null);
  const tireResults = results;
  const [downloadedResources, setDownloadedResources] = useState({
    less_3mm: null,
    IN_USE: null,
    '3_5_mm': null,
    less_3mon: null,
  });
  const [isDownloading, setIsDownloading] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isInitial, setIsInitial] = useState(true);
  const access_token = useSelector(setAccessTokenSelector);

  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);

  const clearCount = () => {
    dispatch(setCount(null));
  };
  const [filterOptions, setFilterOptions] = useState([
    'brand',
    'product_line',
    'last_tread_depth',
    'estimated_tread_depth',
  ]);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterParameters, setFilterParameters] = useState({});
  const [checkedFilters, setCheckedFilters] = useState({});
  const [payloadFilterValues, setPayloadFilterValues] = useState(null);
  const [treadFilterValues, setTreadFilterValues] = useState({});

  const fetchFilterOptions = async () => {
    const params = {
      tire_location: params_.tire_location,
    };
    try {
      const res = await getFilteredTireOverview(params);
      // console.log('response 1', res?.data?.resources);
      let filter_options = res?.data?.resources;
      let current = Object.keys(filter_options).map(x => ({
        key: x,
      }));
      setFilterOptions(filter_options);
      current.forEach(option => {
        // option.title = titlesArray[option.key];

        option.options = filter_options[option.key];

        option.hasInitialValues = filter_options[option.key]?.length
          ? true
          : false;
      });
      console.log('response 2', filterOptions);

      setSelectedFilters([]);
      setFilterParameters({});
      clearCount();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (params_.tire_location && access_token) {
      fetchFilterOptions();
    }
    /*eslint-disable-next-line*/
  }, [access_token, params_.tire_location]);

  const fetchOverview = async () => {
    const overviewDetails = await getVehicleOverviewDetails();
    dispatch(setOverviewDetails(overviewDetails));
  };

  const fetchTirePaginatedData = async (page, location) => {
    clearCount();
    try {
      const params = {
        accessing: 'ONLY_TIRE',
        tire_location: location || params_.tire_location,
        page_no: page,
        per_page: rowsPerPage,
        ...(selectedFilters.length > 0 && {
          filters: filterParameters,
        }),
      };
      dispatch(fetchOverviewDetails(params));
    } catch (error) {
      console.error('E20045');
    }
  };

  const fetchTires = async () => {
    clearCount();
    try {
      const params = {
        accessing: 'ONLY_TIRE',
        tire_location: params_.tire_location,
        page_no: 0,
        per_page: rowsPerPage,
      };
      dispatch(fetchOverviewDetails(params));
    } catch (error) {
      console.error('E20045');
    }
    setSelectedFilters([]);
    setFilterParameters({});
  };

  useEffect(() => {
    if (tireOverview === null && access_token) {
      fetchOverview();
    }
    // eslint-disable-next-line
  }, [access_token]);
  useEffect(() => {
    dispatch(fetchOverviewDetails(params_));

    //eslint-disable-next-line
  }, [fleets]);

  useEffect(() => {
    if (searchQuery?.length >= 2) {
      searchedDataHandler();
    }
    // eslint-disable-next-line
  }, [searchQuery]);

  useEffect(() => {
    if (!isInitial) {
      fetchTirePaginatedData();
    }
    // eslint-disable-next-line
  }, [rowsPerPage, isInitial]);

  const closeFilterHandler = () => {
    setOpenFilterDrawer(false);
  };

  const filterCheckChangeHandler = (e, isCheck) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    const key = e.target.name;
    let obj;

    if (isCheck) {
      setSelectedFilters(prevSelectedFilters => {
        if (isChecked) {
          return [...prevSelectedFilters, value];
        } else {
          return prevSelectedFilters.filter(item => item !== value);
        }
      });
      obj = filterParameters;
      if (isChecked) {
        if (!!obj[key]) {
          obj[key] = [...obj[key], value];
        } else {
          obj[key] = [value];
        }
      } else {
        if (!!obj[key]) {
          if (obj[key]?.length > 1) {
            let temp = obj[key]?.filter(item => item !== value);
            obj[key] = temp;
          } else delete obj[key];
        }
      }
    }
    setFilterParameters(obj);
  };

  const searchedDataHandler = debounce(async () => {
    console.log('search', searchQuery);
    // setLoading(true);
    const params = {
      accessing: 'ONLY_TIRE',
      search_string: searchQuery,
      ...(selectedFilters.length > 0 && {
        filters: filterParameters,
      }),
      tire_location: params_.tire_location,
    };
    try {
      dispatch(fetchOverviewDetails(params));
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false);
    }
  }, 400);

  useEffect(() => {
    if (searchQuery) {
      searchedDataHandler();
    } else if (payloadFilterValues) {
      fetchTirePaginatedData();
    } else {
      fetchTires();
    }
    // eslint-disable-next-line
  }, [searchQuery, access_token]);

  useEffect(() => {
    return () => {
      searchedDataHandler.cancel();
    };
  }, [searchedDataHandler]);

  const filterApplyHandler = async filterValues => {
    try {
      if (
        (selectedFilters.length && Object.values(filterParameters).length) ||
        searchQuery?.length > 0
      ) {
        setPayloadFilterValues(filterValues);
        const params = {
          accessing: 'ONLY_TIRE',
          ...(selectedFilters.length > 0 && {
            filters: filterParameters,
          }),
          page_no: 0,
          per_page: rowsPerPage,
          tire_location: params_.tire_location,
        };
        dispatch(fetchOverviewDetails(params));
      } else {
        setPayloadFilterValues(null);
        fetchTires();
      }
    } catch (err) {
      console.error(err);
    }

    // console.log('Filter Count', count)
    // setFilterCounter(Object.keys(filterValues).length);
    setOpenFilterDrawer(false);
  };

  const filterSearchHandler = (event, filter) => {
    let val = event.target.value;
    const temp = JSON.parse(JSON.stringify(filterOptions));
    if (val.length > 1) {
      const hits = filter?.options?.filter(hit => {
        const stringWithoutSpaces = hit.replace(/\s+/g, '');
        return stringWithoutSpaces.toLowerCase().includes(val);
      });
      const index = temp?.findIndex(item => item.key === filter.key);
      temp[index].options = hits;
    }
  };

  const deleteSelectedFilterHandler = item => {
    setSelectedFilters(prevSelectedFilters => {
      return prevSelectedFilters.filter(clicked => clicked !== item);
    });
    let key = '';
    let obj = filterParameters;
    Object.entries(filterParameters)?.forEach(value => {
      if (value[1]?.includes(item)) {
        key = value[0];
      }
    });
    if (!!obj[key]) {
      if (obj[key]?.length > 1) {
        let temp = obj[key]?.filter(item_ => item_ !== item);
        obj[key] = temp;
      } else delete obj[key];
    }
  };
  const formatNumber = num => {
    if (num === 'N/A') {
      return null;
    }

    const formattedNumber = num?.toLocaleString('de-DE', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
      useGrouping: false,
    });

    return currentLanguage === 'de' ? formattedNumber : num?.toFixed(2);
  };

  const getTotalForCurrentTab = category => {
    if (category === 'optimum_pressure_difference') {
      return tireOverview?.['optimumAirPressureCount'];
    }
    return tireOverview?.[category];
  };

  const [tireValue, setTireValue] = useState(parameters?.tireTabValue || 0);
  const columns = useMemo(
    () => [
      {
        key: 'more',
        title: t('tireConfigPage.more'),
        canSort: false,
        dataHook: 'more',
      },
      {
        key: 'tire_id',
        title: t('tireInventoryItems.titles.tire_id'),
        render: row => (
          <Link
            color='primary'
            style={{
              textDecoration: 'none',
              padding: 5,
              color: theme.palette.primary.main,
            }}
            to={`/tire-inventory/${row.fleet_id}/${row?.system_tire_id}`}
          >
            {row.tire_id}
          </Link>
        ),
        size: 80,
        canSort: true,
        dataHook: 'tire-id',
      },
      {
        key: 'vehicle_name',
        title: t('tireInventoryItems.titles.name'),
        render: row => (
          <>
            {row?.vehicle_name ? (
              <Link
                style={{
                  textDecoration: 'none',
                  padding: 5,
                  color: theme.palette.primary.main,
                }}
                color='primary'
                to={`/fleets-data/${
                  row.fleet_id
                }/${row.vehicle_type.toLowerCase()}s/${row.vehicle_id}`}
              >
                <NAComponent val={row?.vehicle_name} />
                {renderStatus(row?.metadata?.interchange?.status)}
              </Link>
            ) : (
              <>
                <NAComponent val={row?.vehicle_name} />
                {renderStatus(row?.metadata?.interchange?.status)}
              </>
            )}
          </>
        ),
        size: 80,
        canSort: true,
        dataHook: 'vehicle-name',
      },
      {
        key: 'brand',
        title: t('common.tireInventory.tireBrand'),
        size: 80,
        canSort: true,
        dataHook: 'brand',
      },
      {
        key: 'product_line',
        title: t('common.tireInventory.productLines'),
        size: 80,
        canSort: true,
        dataHook: 'product-line',
      },
      {
        key: 'last_tread_depth',
        title: t('tireInventoryItems.titles.treadDepth'),
        render: row => <NAComponent val={formatNumber(row.last_tread_depth)} />,
        size: 80,
        canSort: true,
        dataHook: 'tread-depth',
      },
      {
        key: 'estimated_tread_depth',
        title: t('tireInventoryItems.titles.estimated_current_tread_depth'),
        render: row => (
          <NAComponent val={formatNumber(row.estimated_tread_depth)} />
        ),
        size: 80,
        canSort: true,
        dataHook: 'est-tread-depth',
      },
      {
        key: 'estimated_wear_out_date',
        title: t('tireInventoryItems.titles.monthsLeft'),
        render: row => (
          <NAComponent val={getRemainingMonths(row.estimated_wear_out_date)} />
        ),
        filterVariant: 'range',
        canSort: true,
        dataHook: 'remaining-months',
      },
      {
        key: 'vehicle_status',
        title: t('tireInventoryItems.titles.status'),
        render: row => <NAComponent val={row.vehicle_status} />,
        canSort: true,
        dataHook: 'vehicle-status',
      },
      {
        key: 'axle_position',
        title: t('tireInventoryItems.titles.axlePosition'),
        render: row => <NAComponent val={row.axle_position} />,
        canSort: true,
        dataHook: 'axle-position',
      },
      {
        key: 'vehicle_customer_name',
        title: t('tireInventoryItems.titles.customerName'),
        render: row => <NAComponent val={row?.vehicle_customer_name} />,
        canSort: true,
        dataHook: 'customer-name',
      },
      {
        key: 'last_event_date',
        title: t('tireInventoryItems.titles.lastUpdate'),
        render: row => <NAComponent val={formatDate(row?.last_event_date)} />,
        canSort: true,
        dataHook: 'axle-position',
      },
    ],
    /*eslint-disable-next-line*/
    [i18next.language]
  );
  console.log('tire location', params_.tire_location);
  let tireData = [
    {
      label: t('tireInventoryItems.titles.inUse'),
      component: (
        <TireTable
          tires={tires}
          columns={columns}
          category={'tires_in_use'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          count={
            params_.tire_location === 'IN_USE' && count !== null ? count : null
          }
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'IN_USE'}
        />
      ),
      id: 'IN_USE',
      category: 'tires_in_use',
      county:
        params_.tire_location === 'IN_USE' && count !== null ? count : null,
    },
    {
      label: '<3 mm',
      component: (
        <TireTable
          tires={tires}
          columns={columns}
          category={'less_3mm'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          count={
            params_.tire_location === 'less_3mm' && count !== null
              ? count
              : null
          }
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'LESS_3_MM'}
        />
      ),
      id: 'less_3mm',
      category: 'less_3mm',
      county:
        params_.tire_location === 'less_3mm' && count !== null ? count : null,
    },
    {
      label: '3 - 5 mm',
      component: (
        <TireTable
          tires={tires}
          columns={columns}
          category={'between_3mm_5mm'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          count={
            params_.tire_location === '3_5_mm' && count !== null ? count : null
          }
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'3_5_MM'}
        />
      ),
      id: '3_5_mm',
      category: 'between_3mm_5mm',
      county:
        params_.tire_location === '3_5_mm' && count !== null ? count : null,
    },
    {
      label: t('common.irregular_wear'),
      component: (
        <TireTable
          tires={tires}
          columns={columns}
          category={'grooves_td_diff_gt_2'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          count={
            params_.tire_location === 'grooves_td_diff_gt_2' && count !== null
              ? count
              : null
          }
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'GROOVES_TD_DIFF_GT_2'}
        />
      ),
      id: 'grooves_td_diff_gt_2',
      category: 'grooves_td_diff_gt_2',
      county:
        params_.tire_location === '3_5_mm' && count !== null ? count : null,
    },
    {
      label: t('tireOverviewPage.threeMonths'),
      component: (
        <TireTable
          tires={tires}
          columns={columns}
          category={'within_3mon'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          count={
            params_.tire_location === 'less_3mon' && count !== null
              ? count
              : null
          }
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'LESS_3_MON'}
        />
      ),
      id: 'less_3mon',
      category: 'within_3mon',
      county:
        params_.tire_location === 'less_3mon' && count !== null ? count : null,
    },
    {
      label: 'Optimum Air Pressure',
      component: (
        <TireTable
          tires={tires}
          columns={columns.concat({
            key: 'optimum_pressure_difference',
            title: 'Optimum Pressure Difference (%)',
            render: row => (
              <NAComponent
                val={`${LocaleNumberFormat(row?.optimum_pressure_difference)}`}
              />
            ),
            canSort: true,
            dataHook: 'optimum_pressure_difference',
          })}
          category={'optimum_pressure_difference'}
          fetchPaginatedData={fetchTirePaginatedData}
          getTotalForCurrentTab={getTotalForCurrentTab}
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          count={count}
          setRowsPerPage={setRowsPerPage}
          setIsInitial={setIsInitial}
          section={'AIR_PRESSURE_ANALYTICS'}
        />
      ),
      id: 'optimum_air_pressure',
      category: 'optimum_pressure_difference',
    },
  ];

  tireData = tireData.map(data => {
    let count1 = tireOverview?.[data.category];

    data.count = count !== null ? count : count1;
    return data;
  });

  const handleChange = (event, newValue) => {
    // eslint-disable-next-line
    setTireValue(newValue);
    setParams_({
      ...params_,
      tire_location: tireData[newValue].id,
      accessing: 'ONLY_TIRE',
    });
    dispatch(
      setParameters({
        tireTabValue: newValue,
        tireLocation: tireData[newValue].id,
        accessing: 'ONLY_TIRE',
      })
    );
    fetchTirePaginatedData(0, tireData[newValue].id);
  };
  const renderFilterDrawer = () => {
    if (openFilterDrawer) {
      return (
        <TireOverviewFIlterDrawer
          data-hook='filter-drawer'
          open={openFilterDrawer}
          closeHandler={closeFilterHandler}
          filters={filterOptions}
          selectedFilters={selectedFilters}
          filterParameters={filterParameters}
          checkedFilters={checkedFilters}
          setCheckedFilters={setCheckedFilters}
          setSelectedFilters={setSelectedFilters}
          setFilterParameters={setFilterParameters}
          handleChange={filterCheckChangeHandler}
          apply={filterApplyHandler}
          deleteHandler={deleteSelectedFilterHandler}
          filterSearchHandler={filterSearchHandler}
          treadFilterValues={treadFilterValues}
          setTreadFilterValues={setTreadFilterValues}
        />
      );
    }
  };
  if (!tires) {
    return <Loading />;
  }

  return (
    <>
      <div style={{ maxHeight: '74vh' }}>
        {isDownloading && (
          <LoadAnimation
            loading={isDownloading}
            setLoading={setIsDownloading}
            useMultiple={true}
          />
        )}
        <CommonGridItem
          // count={count}
          setOpenFilterDrawer={setOpenFilterDrawer}
          filterCounter={selectedFilters.length}
          title={t('common.tireOverview')}
          currentTab={tireValue}
          tabs={tireData}
          handleChange={handleChange}
          overview={tireOverview}
          identifier='tire'
          setSearchQuery={setSearchQuery}
          results={tireResults}
          isActive={params_.tire_location}
          downloadResources={() =>
            fetchAllResources(
              tireData,
              tireValue,
              count,
              downloadedResources,
              setDownloadedResources,
              'ONLY_TIRE',
              tireOverview,
              setIsDownloading
            )
          }
        />
      </div>
      {renderFilterDrawer()}
    </>
  );
};

export default TireOverview;

const TireTable = ({
  tires,
  columns,
  fetchPaginatedData,
  getTotalForCurrentTab,
  category,
  count,
  loading,
  rowsPerPage,
  setRowsPerPage,
  setIsInitial,
  section,
}) => {
  const [activeColumns, setActiveColumns] = useState([]);
  const [editColumnsIsOpen, setEditColumnsIsOpen] = useState(false);
  const columnPreference = useSelector(
    state => state.users.tireOverviewColumns
  );
  const access_token = useSelector(setAccessTokenSelector);
  const shownColumns = columns.filter(column =>
    activeColumns.includes(column.key)
  );
  const hiddenColumns = columns.filter(
    column => !activeColumns.includes(column.key)
  );
  const [items, setItems] = useState({
    list1: shownColumns,
    list2: hiddenColumns,
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const getColumnPreference = async () => {
      dispatch(fetchTireOverviewColumnDisplay(`TIRE_OVERVIEW_${section}`));
    };

    if (access_token) {
      getColumnPreference();
    }

    // eslint-disable-next-line
  }, [section, access_token]);

  useEffect(() => {
    const itemsToShow = Object.entries(columnPreference || {}).reduce(
      (acc, [key, value]) => {
        if (value) acc.push(key);
        return acc;
      },
      []
    );

    itemsToShow.unshift('more');
    setActiveColumns(itemsToShow);
    const hiddenColumns = columns.filter(
      column => !itemsToShow.includes(column.key)
    );
    const shownColumns = columns.filter(column =>
      itemsToShow.includes(column.key)
    );
    setItems({
      list1: shownColumns,
      list2: hiddenColumns,
    });

    // eslint-disable-next-line
  }, [columnPreference]);

  const toggleDrawer = newOpen => () => {
    setEditColumnsIsOpen(newOpen);
  };

  return (
    <>
      <Button
        variant='text'
        color='primary'
        style={{ textTransform: 'unset' }}
        onClick={() => setEditColumnsIsOpen(true)}
      >
        {t('columnsEdit.editBtn')}
      </Button>

      <CustomTable
        count={count}
        data={tires || []}
        columns={columns}
        emptyMessage={'No tires available'}
        paginationHandler={fetchPaginatedData}
        freq={
          count !== null && count !== undefined
            ? count
            : getTotalForCurrentTab(category)
        }
        loading={loading}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        isInitialRun={setIsInitial}
        total={
          count !== null && count !== undefined
            ? count
            : getTotalForCurrentTab(category)
        }
        revealedColumns={activeColumns.filter(item => item !== 'multi')}
      />
      <ColumnsEditDrawer
        items={items}
        setItems={setItems}
        setActiveColumns={setActiveColumns}
        editColumnsIsOpen={editColumnsIsOpen}
        toggleDrawer={toggleDrawer}
        setToggleDrawer={setEditColumnsIsOpen}
        section={`TIRE_OVERVIEW_${section}`}
      />
    </>
  );
};
